<ng-container *ngIf="!!get">
    <tt-card class="col-xs-12 col-md-3 p-5">
        <tt-select ttLabel="menugrp_name" [(ttModel)]="get.menugrp_keyno" [ttData]="menuGroups" ttDataId="menugrp_keyno" ttDataName="menugrp_name"></tt-select>
        <tt-button-goto
            ttText="new_p2_webpagelink"
            ttIcon="far fa-plus"
            ttGoto="p2webpagelinkedit"
            [ttGotoParms]="{ p2_webpage_keyno_belongto: get.p2_webpage_keyno, p2_webpagelink_keyno: '0' }"
        ></tt-button-goto>
    </tt-card>

    <tt-grid *ngIf="!!grid" [(ttOptions)]="grid"></tt-grid>
</ng-container>
